import { useClientAppConfigWebHandler_getFeature } from '@zg-rentals/ts-rental-manager-api-beta-client-react-query';

import accessUtils from '../../../../srcLegacy/shared/utils/accessUtils';
import useMultiplexBuildingSessionId from './useMultiplexBuildingSessionId';

/**
 * Hook to determine if the user is in a multiplex listing flow.
 *
 * Checks:
 * 1. Feature flag `canAccessMultiplexListingFlow` via app config
 * 2. Presence of `multiplexBuildingSessionId` query param in URL
 *
 * @returns {Object} - { isLoading, isInMultiplexListingFlow }
 */
const useMultiplexListingFlow = () => {
  const { isReady: isMultiplexBuildingSessionIdReady, multiplexBuildingSessionId } = useMultiplexBuildingSessionId();

  const { isLoading, data = 'false' } = useClientAppConfigWebHandler_getFeature(
    {
      appName: 'zrm_web',
      featureName: 'canAccessMultiplexListingFlow',
    },
    {
      meta: {
        tags: ['multiplexListingFlowAccess'],
        context: {
          api: 'ClientAppConfigWebHandler',
          details: 'canAccessMultiplexListingFlow',
        },
      },
    },
  );

  const canAccessMultiplexListingFlow = accessUtils.canAccessMultiplexListingFlow({
    canAccessMultiplexListingFlowResponse: data,
  });

  const isMultiplexListingFlowLoading = isLoading || !isMultiplexBuildingSessionIdReady;

  const isInMultiplexListingFlow = isMultiplexListingFlowLoading
    ? null
    : canAccessMultiplexListingFlow && Boolean(multiplexBuildingSessionId);

  return {
    isLoading: isMultiplexListingFlowLoading,
    isInMultiplexListingFlow,
  };
};

export default useMultiplexListingFlow;
